module.exports = __webpack_public_path__ + "img/40_teq_y_soda.27399b6f.jpg";